import { matchPath } from 'react-router-dom';
import type { SiblingGroup } from '../types/nav';
import { REALM_ITEMS } from './realmNav';
import { WAR_ITEMS } from './warNav';
import { KINGDOM_ITEMS } from './kingdomNav';
import { WORLD_ITEMS } from './worldNav';

/**
 * SF-146: generalized registry of every Part with a hub+siblings pattern (Realm, War, and future
 * Kingdom/World follow-ups). Replaces `Layout.tsx`'s old hardcoded single-group logic
 * (`SIBLING_ROW_ROUTES`) — `Layout.tsx` now looks up *which* group applies to the current route,
 * not just *whether* one does.
 */
export const REALM_GROUP: SiblingGroup = { key: 'realm', label: 'Realm', items: REALM_ITEMS };
export const WAR_GROUP: SiblingGroup = { key: 'war', label: 'War', items: WAR_ITEMS };
export const KINGDOM_GROUP: SiblingGroup = { key: 'kingdom', label: 'Kingdom', items: KINGDOM_ITEMS };
export const WORLD_GROUP: SiblingGroup = { key: 'world', label: 'World', items: WORLD_ITEMS };

export const SIBLING_GROUPS: readonly SiblingGroup[] = [REALM_GROUP, WAR_GROUP, KINGDOM_GROUP, WORLD_GROUP];

/**
 * `matchPath({ path, end: true })`, not exact string equality — Kingdom (SF-150) and World
 * (SF-155) have parameterized routes (`/world/dossier/:kingdomId?`) that exact
 * equality can never match. `end: true` behaves identically to `===` for every route in this spec.
 */
export function findSiblingGroup(pathname: string): SiblingGroup | undefined {
  return SIBLING_GROUPS.find((group) =>
    group.items.some((item) => !!matchPath({ path: item.route, end: true }, pathname))
  );
}
